import { ApplicationFormHeader } from 'components';
import { FC } from 'react';
import { IApplicationFormLayoutProps } from './types';

export const ApplicationFormLayout: FC<IApplicationFormLayoutProps> = ({ children }) => {
  const segments = location.pathname.split('/');
  const overflowClass = segments[1]?.toLowerCase() === 'application' ? 'overflow-auto' : 'overflow-hidden';
  return (
    <div className={`h-full ${overflowClass}`}>
      <ApplicationFormHeader />
      <div className={'w-full h-full'}>
        <div className={'pt-16 h-full'}>{children}</div>
      </div>
    </div>
  );
};
